export let getResources: (args?: {
    resourceNames?: string[];
    templateNames?: string[];
    locale?: string;
}) => Promise<{ resources: Record<string, string>; templates: Record<string, string> }>;

export function setGetResourcesService(value: typeof getResources) {
    getResources = value;
}

export let getAllTemplates: () => Promise<Record<string, string>>;

export function setGetAllTemplatesService(value: typeof getAllTemplates) {
    getAllTemplates = value;
}
